import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment.prod';
import {Observable} from 'rxjs';
import {clearStorageData, setTokenData, setUserData} from '../utils/auth.utils';
import {TokenData} from '../interfaces/auth.interface';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private http: HttpClient, private router: Router) { }

  public login(username: string, password: string): Observable<TokenData> {
    return new Observable(subscriber => {
      this.http.post(`${environment.apiUrl}/api/oauth/token`, {
        username,
        password,
        grant_type: 'password',
        client_id: 2,
        client_secret: environment.clientSecret
      }).subscribe(
        (response: any) => {
          setTokenData(response);
          subscriber.next(response);
        },
        (err) => { subscriber.error(err); },
      );
    });
  }

  public getUserAuthenticated(): Observable<any> {
    return new Observable(subscriber => {
      this.http.get(`${environment.apiUrl}/authenticated`).subscribe((response: any) => {
        setUserData(response);
        subscriber.next(response);
      });
    });
  }

  public logout(): void {
    clearStorageData();
    this.router.navigate(['/login']).then();
  }
}
